"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AlarmTriggered = function AlarmTriggered(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.5 20.7",
    width: "24.5",
    height: "20.7"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,20.7H0.5c-0.2,0-0.3-0.1-0.4-0.3S0,20.1,0.1,20l3.5-5.8l0.9,0.5l-3,5.1h21.8l-4.1-6.8l0.9-0.5l4.5,7.6 c0.1,0.2,0.1,0.3,0,0.5C24.4,20.6,24.2,20.7,24,20.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11,3.7l-0.9-0.5l1.7-3c0.2-0.3,0.7-0.3,0.9,0l1.7,2.9l-0.9,0.5l-1.2-2.1L11,3.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M19.7,17.2H4.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5c0.6,0,1.1-0.4,1.3-0.9c0.1-0.3,0.4-0.4,0.7-0.3 c0.3,0.1,0.4,0.4,0.3,0.7c-0.1,0.2-0.2,0.4-0.3,0.5h11c-0.3-0.4-0.5-0.9-0.5-1.4v-3.6c0-2.1-1.3-4-3.3-4.7 c-0.2-0.1-0.3-0.2-0.3-0.4c-0.1-0.7-0.7-1.2-1.4-1.2c-0.7,0-1.3,0.5-1.4,1.2c0,0.2-0.1,0.3-0.3,0.4c-1.1,0.4-2,1.2-2.6,2.2 C7.8,8.9,7.5,9,7.2,8.9C7,8.7,6.9,8.4,7.1,8.2c0.7-1.1,1.7-2,2.8-2.5c0.3-1,1.3-1.8,2.4-1.8c1.1,0,2.1,0.7,2.3,1.8 c2.2,0.9,3.7,3.1,3.7,5.5v3.6c0,0.8,0.6,1.4,1.4,1.4c0.3,0,0.5,0.2,0.5,0.5S20,17.2,19.7,17.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M7.2,9.4c-0.1,0-0.1,0-0.2,0C6.8,9.3,6.7,9,6.8,8.7C6.9,8.5,7,8.3,7.1,8.2C7.2,7.9,7.5,7.9,7.7,8 C8,8.1,8.1,8.4,7.9,8.7C7.8,8.8,7.8,9,7.7,9.1C7.6,9.3,7.4,9.4,7.2,9.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M12.2,19.2c-1.3,0-2.4-1.1-2.4-2.4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5c0,0.8,0.6,1.4,1.4,1.4 s1.4-0.6,1.4-1.4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5C14.7,18.1,13.6,19.2,12.2,19.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M8.9,12.4H2.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.3c0.3,0,0.5,0.2,0.5,0.5S9.2,12.4,8.9,12.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M5.7,15.1c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l2.8-2.3L5.5,9.7C5.3,9.5,5.3,9.2,5.5,9 C5.6,8.8,6,8.7,6.2,8.9l3.1,2.6c0.1,0.1,0.2,0.2,0.2,0.4c0,0.1-0.1,0.3-0.2,0.4L6,15C5.9,15.1,5.8,15.1,5.7,15.1z"
  }));
};

var _default = AlarmTriggered;
exports["default"] = _default;